module.exports = __webpack_public_path__ + "img/pic_1_zh.46e7c4b3.png";